import React from 'react';
import { Route } from 'react-router-dom';
import slug from 'constants/slug';
import AuditList from './AuditList';
import AuditCreate from './AuditCreate';
import AuditView from './AuditView';
import AuditEdit from './AuditEdit';
import AuditViewChild from './AuditViewChild';
import AuditEditChild from './AuditEditChild';


export default (props) => [
  <Route
    key={slug.AUDIT.EDIT_CHILD}
    path={slug.AUDIT.EDIT_CHILD}
    render={(matchProps) => <AuditEditChild {...matchProps} {...props} />}
  />,
  <Route
    key={slug.AUDIT.VIEW_CHILD}
    path={slug.AUDIT.VIEW_CHILD}
    render={(matchProps) => <AuditViewChild {...matchProps} {...props} />}
  />,
  <Route
    exact
    key={slug.AUDIT.VIEW}
    path={slug.AUDIT.VIEW}
    render={(matchProps) => <AuditView {...matchProps} {...props} />}
  />,
  <Route
    exact
    key={slug.AUDIT.LIST}
    path={slug.AUDIT.LIST}
    render={(matchProps) => (
      <AuditList isShowExpandSearch {...matchProps} {...props} typeSearch='form_2' />
    )}
  />,
  <Route
    key={slug.AUDIT.CREATE}
    path={slug.AUDIT.CREATE}
    render={(matchProps) => <AuditCreate {...matchProps} {...props} />}
  />,
  <Route
    key={slug.AUDIT.EDIT}
    path={slug.AUDIT.EDIT}
    render={(matchProps) => <AuditEdit {...matchProps} {...props} />}
  />,
];



// WEBPACK FOOTER //
// ./src/containers/FacilityAudit/index.js